var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9993 25.667C20.4427 25.667 25.666 20.4436 25.666 14.0003C25.666 7.557 20.4427 2.33366 13.9993 2.33366C7.55603 2.33366 2.33268 7.557 2.33268 14.0003C2.33268 20.4436 7.55603 25.667 13.9993 25.667ZM13.9993 26.8337C21.087 26.8337 26.8327 21.088 26.8327 14.0003C26.8327 6.91267 21.087 1.16699 13.9993 1.16699C6.91169 1.16699 1.16602 6.91267 1.16602 14.0003C1.16602 21.088 6.91169 26.8337 13.9993 26.8337Z",
    fill: "#2D49FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3708 10.1169L8.95165 16.5433C8.91935 16.5757 8.89603 16.6166 8.88493 16.6606L8.17343 19.5194C8.15214 19.6055 8.17741 19.697 8.24014 19.7598C8.28762 19.8074 8.3523 19.8337 8.41846 19.8337C8.43873 19.8337 8.45945 19.8312 8.47963 19.8261L11.3354 19.1137C11.38 19.1026 11.4204 19.0794 11.4527 19.047L17.8724 12.6211L15.3708 10.1169ZM19.4627 9.24068L18.7482 8.52538C18.2706 8.0473 17.4382 8.04776 16.9612 8.52538L16.0859 9.40158L18.5874 11.9057L19.4627 11.0295C19.7013 10.7908 19.8327 10.4731 19.8327 10.1351C19.8327 9.79722 19.7013 9.47949 19.4627 9.24068Z",
    fill: "#2D49FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleEdit);
export default __webpack_public_path__ + "static/media/CircleEdit.e97ef8a2.svg";
export { ForwardRef as ReactComponent };